import customAxios from "../../customAxios";
import { ACCEPT_PAY_TO_DRIVER} from "../../routes";

type Props = {
  withdrawalId: string[];
};

const acceptManyPayToDriver = async (props: Props) => {
  try {
    return (
      await customAxios.put(ACCEPT_PAY_TO_DRIVER , {
        withdrawalId: props.withdrawalId,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ACCEPT_MANY_PAY_TO_DRIVER: error});
    return false;
  }
};

export default acceptManyPayToDriver;
